import React from "react";
import { Instagram, Linkedin, Mail, BookMarked } from "lucide-react";
import { SOCIAL, PAPERBACK_URL, KINDLE_URL } from "../site-data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1c1a1a] text-[#f9f6f0] py-16"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-serif text-3xl tracking-tight">
            Nitin Sawhney<span className="text-[#8b2e3e]">.</span>
          </p>
          <p className="mt-4 font-serif italic text-[#e5c9c5] text-xl max-w-sm">
            Stories that touch every heart.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow !text-[#e5c9c5] mb-4">Explore</p>
          <ul className="space-y-2 text-sm text-[#f9f6f0]/80">
            <li><a href="#about" className="hover:text-[#e5c9c5]">About</a></li>
            <li><a href="#book" className="hover:text-[#e5c9c5]">The Book</a></li>
            <li><a href="#stories" className="hover:text-[#e5c9c5]">Stories</a></li>
            <li><a href="#works" className="hover:text-[#e5c9c5]">Works</a></li>
            <li><a href="#contact" className="hover:text-[#e5c9c5]">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow !text-[#e5c9c5] mb-4">Elsewhere</p>
          <div className="flex items-center gap-4">
            <a
              href={SOCIAL.instagram}
              target="_blank" rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="h-10 w-10 border border-[#4a4646] flex items-center justify-center hover:border-[#e5c9c5] hover:text-[#e5c9c5] transition-colors"
            >
              <Instagram size={16} />
            </a>
            <a
              href={SOCIAL.linkedin}
              target="_blank" rel="noopener noreferrer"
              aria-label="LinkedIn"
              data-testid="footer-linkedin"
              className="h-10 w-10 border border-[#4a4646] flex items-center justify-center hover:border-[#e5c9c5] hover:text-[#e5c9c5] transition-colors"
            >
              <Linkedin size={16} />
            </a>
            <a
              href={`mailto:${SOCIAL.email}`}
              aria-label="Email"
              data-testid="footer-email"
              className="h-10 w-10 border border-[#4a4646] flex items-center justify-center hover:border-[#e5c9c5] hover:text-[#e5c9c5] transition-colors"
            >
              <Mail size={16} />
            </a>
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={PAPERBACK_URL}
              target="_blank" rel="noopener noreferrer"
              data-testid="footer-buy-btn"
              className="inline-block border border-[#e5c9c5] text-[#e5c9c5] hover:bg-[#8b2e3e] hover:text-white hover:border-[#8b2e3e] px-5 py-2.5 text-xs tracking-[0.2em] uppercase transition-colors"
            >
              Paperback
            </a>
            <a
              href={KINDLE_URL}
              target="_blank" rel="noopener noreferrer"
              data-testid="footer-kindle-btn"
              className="inline-flex items-center gap-2 border border-[#e5c9c5] text-[#e5c9c5] hover:bg-[#e5c9c5] hover:text-[#1c1a1a] px-5 py-2.5 text-xs tracking-[0.2em] uppercase transition-colors"
            >
              <BookMarked size={14} /> Kindle
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-6 border-t border-[#4a4646] flex flex-col md:flex-row justify-between gap-3 text-xs text-[#f9f6f0]/60">
        <p>© {year} Nitin Sawhney. All rights reserved.</p>
        <p>
          Published by <span className="text-[#e5c9c5]">Beeja House</span> · ISBN 978-93-49242-11-1
        </p>
      </div>
    </footer>
  );
}
